import PRProcessForm from '@app/components/apps/PRProcess/PRProcessForm';
import PRProductsForm from '@app/components/apps/PRProducts/PRProductsForm';
import { BaseBreadcrumb, BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';

const routes = [
  {
    path: '/product-registration-processes',
    breadcrumbName: 'Product Registrations Processes',
  },
  {
    path: '/add-product-registration-process',
    breadcrumbName: 'Add Product Registration process',
  },
];

const CreatePRProcessPage = () => {
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Add Product Registration Process');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <PRProcessForm
        editable={true}
        pageTitle={'Create Product Registration Process'}
        type={'create'}
        setCurrentBreadcrumName={setCurrentBreadcrumName}
      />
    </Row>
  );
};

export default CreatePRProcessPage;
